import {Inject, inject, Injectable, InjectionToken} from '@angular/core';
import {StorageService} from './storage.service';
import {Observable, of} from 'rxjs';
import {ApiRemarktypeGetRequestParams} from '../../modules/apiModule';
import {ActivatedRoute} from '@angular/router';

// где-то в модуле или отдельно
export const SYNC_ITEM_NAME_TOKEN = new InjectionToken<string>('FACILITY_SYNC_ITEM_NAME');
export const DATA_FUNCTION_TOKEN = new InjectionToken<(params: ApiRemarktypeGetRequestParams) => Observable<any>>('WindowSyncService.data');
export const DATA_PARAM_TOKEN = new InjectionToken<string>('DATA_PARAM_NAME');

/*
    сервис, который опционально инжектируется и должен обеспечивать следующий интерфейс:
    - выполнение какого-то условия, определающего, что данные нужно получать с из него (has)
    - источник данных возвращающий Observable<any> для подключения в refreshData (data)
    - param - имя параметра, в кторый будет передаваться значение (param)
*/
@Injectable({
    providedIn: 'root'
})
export class WindowSyncService {
    route = inject(ActivatedRoute);
    storage = inject(StorageService);
    syncItemName = 'abstract-sync';
    param = 'abstractIds';
    private cacheValue = '';
    readonly data: (params: ApiRemarktypeGetRequestParams) => Observable<any> = () => of(null);

    constructor(
        @Inject(DATA_FUNCTION_TOKEN) data: (params: ApiRemarktypeGetRequestParams) => Observable<any>,
        @Inject(DATA_PARAM_TOKEN) param: string,
    )
    {
        this.data = data;
        this.param = param;
        this.route.queryParams.subscribe(params => {
            if (params['param']) {
                this.setItemName(params['param']);
            }
        });
    }

    set(str: string, key?: string): void {
        if (key) {
            this.syncItemName = key;
        }
        this.storage.setItem(this.syncItemName, str);
    }

    get(): string {
        if (!this.setItemName) return '';
        const res = this.storage.getItem(this.syncItemName) || '';
        this.cacheValue = res;
        return res;
    }

    get cache(): string {
        if (this.cacheValue) {
            return this.cacheValue;
        } else {
            return this.get();
        }
    }


    has(): boolean {
        const res = this.storage.getItem(this.syncItemName) || '';
        if (res) {
            this.cacheValue = res;
        }
        return !!res;
    }

    remove(): void {
        this.storage.removeItem(this.syncItemName);
    }

    setItemName(name: string): void {
        if (name) {
            this.syncItemName = name;
            this.get();
        }
    }
}
